import { sendRequest, HttpMethods } from "../util/ApiHelper";

const CONTROLLER_NAME = "Employees";

export const getCrafts = async (employeeId: string) => {
    return await sendRequest(
        HttpMethods.GET,
        `${CONTROLLER_NAME}/Crafts`,
        undefined,
        {
            employeeId: employeeId
        }
    );
};

export const getEmployeesLiteList = async (data: any) => {
    return await sendRequest(
        HttpMethods.POST,
        `${CONTROLLER_NAME}/GetLiteList`,
        data
    );
};

// Full data for a single employee, including EmailAddress and the Phone[] array
// (em_employee_phone). Used by the WO Details employee-field contact actions to
// resolve a specific employee's email/phone by id.
export const getDataForEmployee = async (employeeId: string) => {
    return await sendRequest(
        HttpMethods.GET,
        `${CONTROLLER_NAME}/GetDataForEmployee`,
        undefined,
        {
            employeeId: employeeId,
            includeInactive: "true",
            phones: "true",
        }
    );
};

export const findEmployee = async (searchTerm: string) => {
    return await sendRequest(
      HttpMethods.GET,
      `${CONTROLLER_NAME}/Find`,
      undefined,
      {
        searchTerm: searchTerm,
      }
    );
  };
  